import React from 'react';
import { BadgeCheckIcon, ChevronRightIcon, StarIcon } from 'lucide-react';
import { PhotoCarousel } from './PhotoCarousel';
import { FitBadge } from '../ui/FitBadge';
import { Tag } from '../ui/Tag';
import { SongRow } from '../SongRow';
import { baht } from '../../utils/format';
import type { Fit } from '../../utils/fit';
import type { Performer } from '../../types/marketplace';
interface PerformerCardFaceProps {
  performer: Performer;
  fit: Fit;
  travel: number;
  applied?: boolean;
  onDetails?: () => void;
}
export function PerformerCardFace({
  performer,
  fit,
  travel,
  applied,
  onDetails
}: PerformerCardFaceProps) {
  return <article className="relative h-full w-full select-none overflow-hidden rounded-lg bg-surface-2 shadow-[0_16px_48px_rgb(0_0_0/0.18)]" data-id="element-722" data-mp="2fkjxa14wvot">
      <PhotoCarousel photos={performer.photos} alt={performer.name} data-id="element-723" data-mp="1wt3ce5gb5o39" />
      <div className="pointer-events-none absolute inset-x-4 top-5 z-10 flex items-start justify-between gap-2" data-id="element-724" data-mp="1wr8znef6x2a9">
        {applied ? <Tag tone="accent" data-id="element-725" data-mp="3lxesst3rq9xb">Applied</Tag> : <Tag tone="overlay" data-id="element-726" data-mp="3lw3o8r2i0y55">Suggested</Tag>}
        <FitBadge score={fit.score} data-id="element-727" data-mp="3lzj6u3vdspbb" />
      </div>

      <div className="absolute inset-x-3 bottom-3 z-10 rounded-md bg-surface/95 p-4 text-ink backdrop-blur-md" data-id="element-728" data-mp="3pztb9c3iz7o2">
        <div className="flex items-start justify-between gap-3" data-id="element-729" data-mp="3c0aeffg5zir2">
          <div className="min-w-0" data-id="element-730" data-mp="3gxk14nc65gb7">
            <h3 className="flex items-center gap-1.5 text-[22px] font-bold leading-tight tracking-[-0.01em]" data-id="element-731" data-mp="3gylq7vq0s3bx">
              <span className="truncate" data-id="element-732" data-mp="8j2035knb113">{performer.name}</span>
              {performer.verified && <BadgeCheckIcon className="h-5 w-5 shrink-0 text-brand-strong" aria-label="Verified" data-id="element-733" data-mp="dgtrlyhdol4r" />}
            </h3>
            <p className="mt-1 flex items-center gap-1 truncate text-sm text-ink-2" data-id="element-734" data-mp="3uxl54bnqd3uw">
              {performer.actType}
              {performer.members > 1 ? ` · ${performer.members}-piece` : ''} ·
              <StarIcon className="h-3.5 w-3.5 fill-current text-brand-strong" aria-hidden="true" data-id="element-735" data-mp="rftcqw5omhw6" />
              <span className="tabular" data-id="element-736" data-mp="w9xodspw7e3l">{performer.rating.toFixed(1)}</span> · {performer.distanceKm} km
            </p>
          </div>
          <div className="shrink-0 text-right" data-id="element-737" data-mp="11503b7lx2fuk">
            <p className="tabular text-lg font-bold leading-tight" data-id="element-738" data-mp="1159sisz50iz7">{baht(performer.price)}</p>
            <p className="tabular text-xs text-ink-3" data-id="element-739" data-mp="w42liw4tjntl">+ {baht(travel)} travel</p>
          </div>
        </div>
        <div className="mt-3 grid gap-2" data-id="element-740" data-mp="s3sgpmsrj3gb">
          {performer.keys.slice(0, 2).map(k => <SongRow key={k.id} song={k} compact data-id="element-741" data-mp="n6jvfdcbijau" />)}
        </div>
        <button type="button" onClick={onDetails} className="mt-3 flex w-full items-center justify-between gap-3 border-t border-line pt-3 text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand" data-id="element-742" data-mp="id7jo3sqm6zi">
          <span className="truncate text-sm text-ink-2" data-id="element-743" data-mp="4ehkmimcxx8i">{fit.reason}</span>
          <span className="flex shrink-0 items-center text-sm font-bold" data-id="element-744" data-mp="4gk9v0formc6">
            Profile <ChevronRightIcon className="h-4 w-4" data-id="element-745" data-mp="3vlal1k9btsbz" />
          </span>
        </button>
      </div>
    </article>;
}